/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-check': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g transform="translate(1 1)" _fill="none" fill-rule="evenodd"><circle pid="0" _stroke="#599ECA" stroke-width="2" cx="9" cy="9" r="9"/><path pid="1" d="M6.35 13.207l4.098-3.958-3.971-4.113 1.53-1.478 5.437 5.63-5.63 5.436-1.464-1.517z" _fill="#599ECA"/></g>'
  }
})
